import { SupervisedUserCircle } from '@mui/icons-material'
import { Divider, Drawer } from '@mui/material'
// import { useOrderStore } from 'modules/orders/store'
import {
  MdOutlineGroup,
  MdOutlineRequestPage,
  MdOutlineSettings
} from 'react-icons/md'
import { useLocation } from 'react-router-dom'
// import { useNavigate } from 'react-router-dom'
import { useLayoutContext } from '../../layout/layout.context'
import { useAuth } from '../../lib/auth'

import { MenuItem } from './components'

import './style.css'

interface SidebarProps {
  show?: boolean
  onClose: any
}

export const Sidebar = (props: SidebarProps) => {
  const { show } = props
  const { user } = useAuth()
  const { setShowSidebar } = useLayoutContext()
  const { pathname } = useLocation()
  // const resetForm = useOrderStore.useResetForm()

  const getCurrentModule = (pathname: string) => {
    return pathname.split('/')[1]
  }

  return (
    <>
      <Drawer
        className="drawer"
        sx={{
          width: 250,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: 250,
            boxSizing: 'border-box',
            borderRight: 'none'
          },
          zIndex: 999,
          height: '100vh'
        }}
        variant="temporary"
        anchor="left"
        open={show}
        onBackdropClick={() => setShowSidebar(false)}
      >
        <div
          style={{
            display: 'flex',
            justifyItems: 'center',
            alignItems: 'center',
            marginBottom: 16
          }}
        >
          <div
            style={{
              display: show ? 'flex' : 'none',
              flex: 1,
              justifyContent: 'center'
            }}
          >
            <div
              style={{
                background: '#f2f5f9',
                width: 200,
                borderRadius: 4,
                marginBottom: 10,
                marginTop: 10
              }}
            >
              <div
                style={{
                  padding: '8px 8px 8px 8px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <div style={{ marginLeft: 10 }}>
                  <div
                    style={{
                      fontWeight: 500,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      width: '170px'
                    }}
                  >
                    {user?.fullName}
                  </div>
                  <div
                    style={{
                      fontSize: 10,
                      fontWeight: 500,
                      color: '#023770',
                      marginTop: 2
                    }}
                  >
                    {user?.companyId} - {user?.roleDescription}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ paddingLeft: 16, paddingRight: 16 }}>
          <div
            style={{
              display: show ? 'flex' : 'none',
              flex: 1,
              overflow: 'auto',
              justifyContent: 'center',
              marginBottom: 16
            }}
          >
            {/* <Button
              startIcon={<HiPlus size={18} />}
              style={{ background: '#023770' }}
              onClick={() => {
                resetForm()
                navigation('orders/create')
              }}
              disabled
            >
              Novo Orçamento
            </Button> */}
          </div>
          <div style={{ marginBottom: 8 }}>
            <MenuItem
              icon={<MdOutlineGroup size={24} className="icon" />}
              name={show ? 'Clientes' : ''}
              to="/customers"
              active={getCurrentModule(pathname) === 'customers'}
            />
            <MenuItem
              icon={<MdOutlineRequestPage size={24} className="icon" />}
              name={show ? 'Pedidos' : ''}
              to="/orders"
              active={getCurrentModule(pathname) === 'orders'}
            />
            {user?.role === 'ADM' && (
              <>
                <MenuItem
                  icon={
                    <SupervisedUserCircle
                      style={{ fontSize: 24 }}
                      className="icon"
                    />
                  }
                  name={show ? 'Usuários' : ''}
                  to="/users"
                  active={getCurrentModule(pathname) === 'users'}
                />
                <MenuItem
                  icon={<MdOutlineSettings size={24} className="icon" />}
                  name="Configurações"
                  to="/settings"
                  active={getCurrentModule(pathname) === 'settings'}
                />
              </>
            )}
          </div>
          <Divider />
        </div>
      </Drawer>
      <div
        className="container"
        style={{
          width: 200,
          marginLeft: show ? 0 : -233,
          paddingLeft: 16,
          paddingRight: 16,
          transitionDuration: '300ms',
          borderRight: '1px solid #e0e0e0',
          height: '100vh'
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyItems: 'center',
            alignItems: 'center',
            marginBottom: 16,
            marginTop: 3
          }}
        >
          <div
            style={{
              flex: 1,
              justifyContent: 'center'
            }}
          >
            <div
              style={{
                background: '#f2f5f9',
                width: 200,
                borderRadius: 4,
                marginBottom: 10,
                marginTop: 75
              }}
            >
              <div
                style={{
                  padding: '8px 8px 8px 8px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <div style={{ marginLeft: 10 }}>
                  <div
                    style={{
                      fontWeight: 500,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      width: '170px'
                    }}
                  >
                    {user?.fullName}
                  </div>
                  <div
                    style={{
                      fontSize: 10,
                      fontWeight: 500,
                      color: '#023770',
                      marginTop: 2
                    }}
                  >
                    {user?.companyId} - {user?.roleDescription}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flex: 1,
            overflow: 'auto',
            justifyContent: 'center',
            marginBottom: 16
          }}
        >
          {/* <Button
            startIcon={<HiPlus size={18} />}
            style={{ background: '#023770' }}
            onClick={() => {
              resetForm()
              navigation('orders/create')
            }}
            disabled
          >
            Novo Orçamento
          </Button> */}
        </div>
        <div style={{ marginBottom: 8 }}>
          <MenuItem
            icon={<MdOutlineGroup size={24} className="icon" />}
            name="Clientes"
            to="/customers"
            active={getCurrentModule(pathname) === 'customers'}
          />
          <MenuItem
            icon={<MdOutlineRequestPage size={24} className="icon" />}
            name="Pedidos"
            to="/orders"
            active={getCurrentModule(pathname) === 'orders'}
          />
          {user?.role === 'ADM' && (
            <>
              <MenuItem
                icon={
                  <SupervisedUserCircle
                    style={{ fontSize: 24 }}
                    className="icon"
                  />
                }
                name={show ? 'Usuários' : ''}
                to="/users"
                active={getCurrentModule(pathname) === 'users'}
              />

              <MenuItem
                icon={<MdOutlineSettings size={24} className="icon" />}
                name="Configurações"
                to="/settings"
                active={getCurrentModule(pathname) === 'settings'}
              />
            </>
          )}
        </div>
        <Divider />
      </div>
    </>
  )
}

Sidebar.defaultPtops = {
  show: false
}
